// ------------------------------------------------------ Our Work Nav //
$('body').on('click', '#our-work-nav li', function(e) {
  e.preventDefault();
  const name = $(this).data('name');

  $('#our-work-nav  li').removeClass('active');
  $(`li[data-name="${name}"`).addClass('active');

  let pageName = `/${name}`;

  $('.slide').removeClass('open active').addClass('hide');
  $(`.slide.${name}`).removeClass('hide').addClass('open active');

  if (name === 'all') {
    pageName = '';
    $('.slide').removeClass('hide open active');
    $('.slide.media-coverage').addClass('active');
  }

  $(`.${name} .box:first-child`).addClass('vis');

  // Update page URL //
  window.history.replaceState(pageName, pageName, `/our-work${pageName}`);

  if (!mobileAndTabletCheck()) {
    pageDownScroll('smooth', window.innerHeight);
  }
});

// ------------------------------------------------------ Turn off active box //
$('body').on('mouseover', '.box', () => {
  $('.box').removeClass('vis');
});

// ------------------------------------------------------ Create Group Section Objects //
function GroupSection(section) {
  this.startPos = 0;
  this.step = 1;
  this.totalSteps = document.getElementsByClassName(section).length;
}

let mediaCoverage = new GroupSection('mc-step');
let pressReleases = new GroupSection('pr-step');
let blog = new GroupSection('blog-step');
let caseStudies = new GroupSection('cs-step');
let whitePapers = new GroupSection('wp-step');

// ------------------------------------------------------ Slider Navs //
$('body').on('click', '.slider-nav span', function() {
  const nav = $(this).data('nav');
  const direction = $(this).data('dir');
  const stepsWidth = document.getElementById(nav).offsetWidth;
  let group;

  // Get specific group object //
  if (nav === 'mc-steps') {
    group = mediaCoverage;
  }
  else if (nav === 'pr-steps') {
    group = pressReleases;
  }
  else if (nav === 'b-steps') {
    group = blog;
  }
  else if (nav === 'cs-steps') {
    group = caseStudies;
  }
  else if (nav === 'wp-steps') {
    group = whitePapers;
  }

  $(`#${nav} .step-${group.step}`).removeClass('active');

  // Step back //
  if (direction === 'back' && group.step > 1) {
    $(`#${nav}`).css('left', group.startPos + stepsWidth);
    group.startPos += stepsWidth;
    group.step -= 1;
  }

  // Step forward //
  if (direction === 'fwd' && group.step < group.totalSteps) {
    $(`#${nav}`).css('left', group.startPos - stepsWidth);
    group.startPos -= stepsWidth;
    group.step += 1;
  }

  $(`#${nav}.step-${group.step}`).addClass('active');

  // Update group object //
  if (nav === 'mc-nav') {
    mediaCoverage = group;
  }
  else if (nav === 'pr-nav') {
    pressReleases = group;
  }
  else if (nav === 'b-nav') {
    blog = group;
  }
  else if (nav === 'cs-nav') {
    caseStudies = group;
  }
  else if (nav === 'wp-steps') {
    whitePapers = group;
  }
});

// ------------------------------------------------------ Article Link //
$('body').on('click', '.box', function() {
  const id = $(this).data('id');
  const type = $(this).data('type');
  const slug = $(this).data('slug');
  const fileName = $(this).data('file');
  const title = $(this).data('title');

  if (slug === 'no-link') {
    return false;
  }
  else if (type === 'white-papers') {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    $('#modal-cover').delay(750).fadeIn('fast');
    $('#whitepaper-modal').delay(750).fadeIn('fast');
    $('#whitepaper-title').val(title);
    $('#whitepaper-modal h1').text(title);
    $('#whitepaper-filename').val(fileName);
    $('#whitepaper-id').val(id);
  }
  else if (fileName) {
    const href = `//s3.amazonaws.com/spartacus-prod/news_causaliq/${id}/${fileName}`;
    forceDownload(href, fileName);
  }
  else {
    window.location.href = `/our-work/${type}/${slug}`;
  }
  return false;
});

// ------------------------------------------------------ White Paper Form & Modal //

$('body').on('click', '#modal-cover', () => {
  $('#modal-cover').fadeOut('fast');
  $('#whitepaper-modal').fadeOut('fast');
});

$('#whitepaper-form-submit').click(() => {
  $('#whitepaper-form').submit();
});

_validator = $('#whitepaper-form').validate({
  ignore: [],
  onfocusout(element) {
    $(element).valid();
  },
  rules: {
    first_name: {
      required: true,
    },
    last_name: {
      required: true,
    },
    email: {
      required: true,
      email: true,
    },
    company: {
      required: true,
    },
  },
  messages: {
    first_name: {
      required: 'First Name is required.',
    },
    last_name: {
      required: 'Last Name is required.',
    },
    email: {
      required: 'Email is required.',
    },
    company: {
      required: 'Company is required.',
    },
  },
  highlight(element) {
    $(element).closest('div').addClass('error').removeClass('valid');
  },
  unhighlight(element) {
    $(element).closest('div').removeClass('error').addClass('valid');
  },
  errorPlacement(error, element) {
    const message = error.html();

    if (message.length > 0) {
      $(element[0]).closest('div.error').append(error);
    }
  },
  // ---------------------------------------------------- FORM SUBMIT HANDLER //
  submitHandler() {
    $('#contact-form-submit').attr('disabled', 'disabled');

    $.ajax({
      url: '/ajax/ourwork/whitepaper',
      type: 'POST',
      dataType: 'json',
      data: $('form').serialize(),
    })
      .done(response => {
        if (!response.err) {
          const fileName = $('#whitepaper-filename').val();
          const id = $('#whitepaper-id').val();
          const href = `//s3.amazonaws.com/spartacus-prod/news_causaliq/${id}/${fileName}`;
          forceDownload(href, fileName);
          $('#whitepaper-form').fadeOut('fast', () => {
            $('#whitepaper-form-thankyou').fadeIn('fast');
          });
        }
        else {
          alert(response.msg);
          console.error(response.response);
          $('#contact-form-submit').removeAttr('disabled');
        }
      })
      .fail(() => {
        $('#contact-form-submit').removeAttr('disabled');
      });
  },
});

// ------------------------------------------------------ Force Downloads //
function forceDownload(href, fileName) {
  const link = document.createElement('a');

  link.setAttribute('href', href);
  link.setAttribute('download', fileName);
  link.setAttribute('target', '_blank');
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// ------------------------------------------------------ Update sliders positions on page resize //
function updateSlidersPosition() {
  $('.boxes-container').css('left', '0');
  mediaCoverage = new GroupSection('mc-step');
  pressReleases = new GroupSection('pr-step');
  blog = new GroupSection('blog-step');
  caseStudies = new GroupSection('cs-step');
  whitePapers = new GroupSection('wp-step');
}

window.addEventListener('resize', updateSlidersPosition, false);
